module.exports = __webpack_public_path__ + "img/as.caaf405.svg";